import { TableComp as Table } from "src/base-components/Table";
import { Columns } from "src/userManagement/userPermissions/UserGranularRolesTable";

export const UserGranularRolesTableSkeleton: React.FC = () => (
  <div className="pt-4">
    <Table
      columns={Columns}
      data={[]}
      dataLoc="granular-roles-table-skeleton"
      disableVirtualization
      isLoading
      loadingRowsCount={5}
    />
  </div>
);
